export default __webpack_public_path__ + "static/media/icon_fire_smoke_off.e728441a.png";